import { Action } from '@ngrx/store';

export enum AlertActions {
    ShowAlert = '[Alert] Show',
    HideAlert = '[Alert] Hide',
}

export class ShowAlert implements Action {
    readonly type = AlertActions.ShowAlert;
    constructor(
        public payload: {
            message: string;
            type: 'error' | 'success' | 'info' | 'warning';
        }
    ) {}
}

export class HideAlert implements Action {
    readonly type = AlertActions.HideAlert;
}

export type AlertActionsUnion = ShowAlert | HideAlert;
